module.exports = __webpack_public_path__ + "menu_expander_opened.png?9bcf4c8e3ffa7880ac25439b66f21798";


//////////////////
// WEBPACK FOOTER
// ./images/menu_expander_opened.png
// module id = 165
// module chunks = 0